/* destinos.js
 * Mapa centralizado: rol → ruta de aterrizaje tras login.
 *
 * Único punto de verdad. Si en un futuro agregamos un usuario nuevo en BD,
 * basta con que su `rol` esté listado aquí y aterrizará donde corresponda
 * — no se toca ningún otro archivo.
 *
 * Octavio 20-jun-2026.
 */

export const DESTINO_POR_ROL = {
  // Administración global
  admin: "/hub",

  // Combustible administrativo
  coordinadora_administrativa: "/combustible",
  jefa_capturistas: "/combustible",
  capturista_combustible: "/combustible",

  // Captura de Pipas (Yanett y similares)
  capturista: "/captura",
  capturista_ac: "/capturista-ac",

  // Pipas — supervisión y coordinación
  supervisor_general_pipas: "/hub",
  supervisor_pipas: "/supervisor",
  coordinador_pipas: "/resumen-ejecutivo",
  jefe: "/resumen-ejecutivo",

  // Pipas — sub-roles operativos
  supervisor_areas: "/areas",

  // Dirección (sólo lectura ejecutiva)
  director: "/reporte-diario",

  // Vialidades (módulo independiente)
  mesa_vial: "/vialidades",
  visor_vial: "/vialidades",
  supervisor_vial: "/vialidades",
  lider_vial: "/vialidades",
  jefe_vial: "/vialidades",

  // Control Vehicular
  control_vehicular: "/admin/control-vehicular",

  // Control de Taller (Gelacio, Juan) — Intervenciones hoy únicamente
  control_taller: "/supervisor",

  // Trabajos Especiales (Fontanería / Herrería)
  capturista_trabajos_especiales: "/hub",
};

/**
 * Devuelve la ruta de aterrizaje para un rol. Default `/hub`.
 * Choferes son una excepción: tienen su propia app en `/chofer`.
 */
export function destinoParaRol(rol) {
  if (!rol) return "/login";
  if (rol === "chofer") return "/chofer";
  return DESTINO_POR_ROL[rol] || "/hub";
}
